

















import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';
import { debounce } from 'throttle-debounce';
import E2EMixin from '@/components/mixins/E2EMixin';
import { i18n, i18nHints } from '@/plugins/i18n';
import { isNullOrUndefined } from '@/utils/boolean';
import { ValidationObserver } from 'vee-validate';

export default mixins(E2EMixin).extend({
  components: {
    ValidationObserver,
  },
  props: {
    // TODO make it required
    name: {
      type: String,
      default: '',
    },
    pErrors: {
      type: Array as PropType<string[]>,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isAlertPageLeaving: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    // auto focus to first input
    this.$nextTick(() => {
      const $form = this.$refs.form;
      if ($form) {
        const firstInput = $form.querySelectorAll('input')[0];
        if (firstInput) firstInput.focus();
      }
    });
    window.addEventListener('beforeunload', this.alertPageLeaving);
  },
  computed: {
    observer(): InstanceType<typeof ValidationObserver> {
      return this.$refs.observer;
    },
  },
  methods: {
    onSubmit: debounce(100, true, async function() {
      // Skip if while loading
      if (this.isLoading) return;

      const isValid = await this.observer.validate();
      if (!isValid) {
        this.$notifyError(i18n.tc(i18nHints.common.notification.check_input));
        return;
      }
      this.$emit('submit');
    }),
    alertPageLeaving(e) {
      if (!this.isAlertPageLeaving) return;

      // FIXME Find another way (It was able to get a dirty state via `v-slot={ dirty }`)
      const fields = this.observer.fields;
      const isFormDirty = Object.keys(fields).some(k => fields[k]?.dirty);
      if (isFormDirty) {
        e.returnValue = 'ページ内容が保存されていません。よろしいですか？';
      }
    },
    /**
     * Call this when you reset the validation state.
     * For example, you have to call this before redirecting the page.
     */
    resetValidator() {
      this.observer.reset();
    },
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.alertPageLeaving);
  },
});
